
import { defineComponent, reactive, ref } from 'vue';
import {
  OioSpin,
  OioPagination,
  OioButton,
  OioModal,
  OioForm,
  OioFormItem,
  OioInput,
  OioCol,
  OioRow
} from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'ActivityAddBtn',
  components: {
    OioSpin,
    OioPagination,
    OioButton,
    OioModal,
    OioForm,
    OioFormItem,
    OioInput,
    OioCol,
    OioRow
  },
  props: ['getTableData', 'getTableDataRemote', 'setRootTableData', 'queryRemote', 'getPropKeyName'],
  setup(props, ctx) {
    const tableRef = ref<any>();
    const tableData = ref<any[]>([]); // 所有数据池
    const showData = ref<any[]>([]); // 用于展示的数据
    const paginationData = ref<any[]>([]); // 用于分页的数据池
    const isAllChecked = ref(false);
    const isIndeterminate = ref(false);
    const selectRecords = ref<any[]>([]);
    const showModal = ref(false);
    const tableLoading = ref(false);
    const current = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const searchData = reactive({
      targetPartnerCode: '',
      customerErpCode: '',
      targetPartnerName: ''
    });

    const checkboxChangeEvent = () => {
      const $table = tableRef.value;
      if ($table) {
        isAllChecked.value = $table.isAllCheckboxChecked();
        isIndeterminate.value = $table.isAllCheckboxIndeterminate();
        selectRecords.value = $table.getCheckboxRecords();
      }
    };

    const onShowModal = () => {
      tableRef.value?.clearCheckboxRow();
      current.value = 1;
      pageSize.value = 10;
      tableData.value = props.getTableData();
      paginationData.value = tableData.value;
      total.value = paginationData.value.length;
      onChange(1, 10);
      showModal.value = true;
    };

    const onShowModalRemote = async () => {
      showModal.value = true;
      tableRef.value?.clearCheckboxRow();
      current.value = 1;
      pageSize.value = 10;
      await onChangeRemote(current.value, pageSize.value);
    };

    const onChange = (page, size) => {
      const start = (page - 1) * size;
      const end = start + size;
      showData.value = paginationData.value.slice(start, end);
    };

    const onChangeRemote = async (currentPage, size) => {
      tableLoading.value = true;
      try {
        const { content, totalElements } = await props.getTableDataRemote({
          currentPage,
          size,
          ...searchData
        });
        showData.value = content ?? [];
        total.value = Number(totalElements ?? 0);
      } finally {
        tableLoading.value = false;
      }
    };

    const onConfirm = () => {
      if (selectRecords.value.length) {
        props.setRootTableData(selectRecords.value);
      }
      showModal.value = false;
    };

    const onSearch = () => {
      tableLoading.value = true;

      let resultArr: any = [];
      if (searchData.customerErpCode.trim()) {
        resultArr = tableData.value.filter((i) => i.customerErpCode.includes(searchData.customerErpCode));
      }
      tableData.value.forEach((i) => {
        if (searchData.customerErpCode.trim() && !i.customerErpCode.includes(searchData.customerErpCode)) {
          return;
        }
        if (searchData.targetPartnerCode.trim() && !i.targetPartnerCode.includes(searchData.targetPartnerCode)) {
          return;
        }
        if (searchData.targetPartnerName.trim() && !i.targetPartnerName.includes(searchData.targetPartnerName)) {
          return;
        }
        resultArr.push(i);
      });

      paginationData.value = resultArr;

      current.value = 1;
      pageSize.value = 10;
      total.value = paginationData.value.length;
      onChange(1, 10);

      tableLoading.value = false;
    };

    const onSearchRemote = async () => {
      await onChangeRemote(current.value, pageSize.value);
    };

    return {
      tableData,
      tableRef,
      checkboxChangeEvent,
      isAllChecked,
      isIndeterminate,
      selectRecords,
      showModal,
      tableLoading,
      current,
      pageSize,
      total,
      onShowModal,
      onShowModalRemote,
      onChange,
      onChangeRemote,
      onConfirm,
      searchData,
      showData,
      onSearch,
      onSearchRemote,
      paginationData
    };
  }
});
